module.exports = __webpack_public_path__ + "static/media/heatmapOverlayTop.90f80a71.png";